import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import core from '@gin-betting/core';
import { noop } from 'lodash';

import { Icon } from 'components';
import { getSummaryPath } from '../../../../utils';
import messages from '../../../Categorizer/messages.js'; // TODO: probably need to move this in root translations
import { OutrightsBySportContext } from '../../OutrightsBySportContext';
import TournamentItem from '../TournamentItem';
import TournamentItemWrapper from '../TournamentItemWrapper';

import summariesIcon from 'assets/svg/summaries.svg';
import './sportSummaryRow.scss';

const {
    utils: { getAppliedFilters },
} = core;

const SportSummaryRow: React.FC = () => {
    const { outrightsCountBySport } = useContext(OutrightsBySportContext);

    const { formatMessage } = useIntl();

    const { sportId } = getAppliedFilters();

    if (!sportId) return null;

    const count = outrightsCountBySport[sportId] || 0;

    if (count < 1) return null;

    return (
        <Link to={getSummaryPath(sportId)}>
            <TournamentItemWrapper onClick={noop}>
                <TournamentItem
                    count={count}
                    title={formatMessage(messages.summaries)}
                >
                    <div styleName="icon">
                        <Icon glyph={summariesIcon} />
                    </div>
                </TournamentItem>
            </TournamentItemWrapper>
        </Link>
    );
};

export default SportSummaryRow;
